<template>
  <div>
    <div class="seccion-titulo"><i class="bi bi-truck me-2"></i>Selecciona tipo de unidad</div>
    <div class="row g-3 mb-4">
      <div class="col-md-6">
        <label class="form-label form-label-sm">Tipo de unidad</label>
        <select class="form-select form-select-sm" v-model="unidadSeleccionada">
          <option disabled value="">Selecciona una unidad</option>
          <option v-for="unidad in unidades" :key="unidad.tipo_unidad" :value="unidad">{{ unidad.tipo_unidad }}</option>
        </select>
      </div>
    </div>

    <div v-if="unidadSeleccionada && unidadSeleccionada.tipo_unidad" class="detalle-unidad">
      <div class="seccion-titulo mt-2"><i class="bi bi-info-circle me-2"></i>Detalle de la unidad</div>
      <div class="detalle-grid">
        <div class="detalle-item">
          <div class="detalle-label">Capacidad de peso</div>
          <div class="detalle-valor">{{ unidadSeleccionada.capacidad_carga }}</div>
        </div>
        <div class="detalle-item">
          <div class="detalle-label">Capacidad de carga</div>
          <div class="detalle-valor">{{ unidadSeleccionada.capacidad_carga_tn }} m³</div>
        </div>
        <div class="detalle-item">
          <div class="detalle-label">Medidas</div>
          <div class="detalle-valor">{{ unidadSeleccionada.medidas_transporte }}</div>
        </div>
        <div class="detalle-item">
          <div class="detalle-label">Horario laboral</div>
          <div class="detalle-valor">{{ unidadSeleccionada.horario_laboral }}</div>
        </div>
        <div class="detalle-item">
          <div class="detalle-label">Costo hora extra</div>
          <div class="detalle-valor">S/ {{ unidadSeleccionada.costo_hora_extra }}</div>
        </div>
        <div v-if="unidadSeleccionada.costo_auxiliar" class="detalle-item">
          <div class="detalle-label">Auxiliar extra</div>
          <div class="detalle-valor">S/ {{ unidadSeleccionada.costo_auxiliar }}</div>
        </div>
        <div v-if="unidadSeleccionada.costo_cuadrilla" class="detalle-item">
          <div class="detalle-label">Cuadrilla</div>
          <div class="detalle-valor">S/ {{ unidadSeleccionada.costo_cuadrilla }}</div>
        </div>
      </div>

      <div class="precios-grid mt-3">
        <div class="precio-card">
          <div class="precio-card-label">Costo diario</div>
          <div class="precio-card-valor">S/ {{ unidadSeleccionada.costo_diario }}</div>
        </div>
        <div class="precio-card">
          <div class="precio-card-label">Costo mensual</div>
          <div class="precio-card-valor">S/ {{ unidadSeleccionada.costo_mensual }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CalculadoraUnidades',
  data() {
    return { unidadSeleccionada: {}, unidades: [] };
  },
  mounted() { this.getVehiculos(); },
  methods: {
    async getVehiculos() {
      try { const res = await axios.get('/tipo-unidades'); this.unidades = res.data; }
      catch (e) { console.error(e); }
    }
  }
};
</script>

<style scoped>
.seccion-titulo { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; color: #3f51b5; border-bottom: 2px solid #e8eaf6; padding-bottom: 6px; margin-bottom: 14px; }
.detalle-grid { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 8px; }
.detalle-item { background: #f8f9ff; border: 1px solid #e8eaf6; border-radius: 8px; padding: 10px 14px; min-width: 140px; }
.detalle-label { font-size: 0.68rem; color: #9e9e9e; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 3px; }
.detalle-valor { font-size: 0.88rem; font-weight: 600; color: #37474f; }
.precios-grid { display: flex; gap: 12px; flex-wrap: wrap; }
.precio-card { background: linear-gradient(135deg, #e8eaf6 0%, #f5f6ff 100%); border: 1px solid #c5cae9; border-radius: 10px; padding: 14px 20px; flex: 1; min-width: 150px; text-align: center; }
.precio-card-label { font-size: 0.75rem; color: #5c6bc0; margin-bottom: 4px; }
.precio-card-valor { font-size: 1.3rem; font-weight: 800; color: #3f51b5; }
</style>
